import { gql } from '@apollo/client';

export const AVAILABLE_FLATS_QUERY = gql`
    query FlatsCountsByFloor(
        $investmentBuilding: [String]
        $investmentFloor: [String]
        $id: ID!
    ) {
        availableFlats: investments(
            first: 0
            where: {
                status: PUBLISH
                parent: $id
                taxQuery: {
                    relation: AND
                    taxArray: [
                        { field: SLUG, taxonomy: INVESTMENTTYPE, terms: "flat" }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTBUILDING
                            terms: $investmentBuilding
                        }
                        {
                            field: SLUG
                            taxonomy: BUILDINGFLOOR
                            terms: $investmentFloor
                        }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTSTATUS
                            terms: "available"
                        }
                    ]
                }
            }
        ) {
            pageInfo {
                total
            }
        }
        bookedFlats: investments(
            first: 0
            where: {
                status: PUBLISH
                parent: $id
                taxQuery: {
                    relation: AND
                    taxArray: [
                        { field: SLUG, taxonomy: INVESTMENTTYPE, terms: "flat" }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTBUILDING
                            terms: $investmentBuilding
                        }
                        {
                            field: SLUG
                            taxonomy: BUILDINGFLOOR
                            terms: $investmentFloor
                        }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTSTATUS
                            terms: "booked"
                        }
                    ]
                }
            }
        ) {
            pageInfo {
                total
            }
        }
        soldFlats: investments(
            first: 0
            where: {
                status: PUBLISH
                parent: $id
                taxQuery: {
                    relation: AND
                    taxArray: [
                        { field: SLUG, taxonomy: INVESTMENTTYPE, terms: "flat" }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTBUILDING
                            terms: $investmentBuilding
                        }
                        {
                            field: SLUG
                            taxonomy: BUILDINGFLOOR
                            terms: $investmentFloor
                        }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTSTATUS
                            terms: "sold"
                        }
                    ]
                }
            }
        ) {
            pageInfo {
                total
            }
        }
    }
`;

export const ALL_AVAILABLE_FLATS_QUERY = gql`
    query FlatsCountsByFloor($id: ID!) {
        availableFlats: investments(
            first: 0
            where: {
                status: PUBLISH
                parent: $id
                taxQuery: {
                    relation: AND
                    taxArray: [
                        { field: SLUG, taxonomy: INVESTMENTTYPE, terms: "flat" }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTSTATUS
                            terms: "available"
                        }
                    ]
                }
            }
        ) {
            pageInfo {
                total
            }
        }
        bookedFlats: investments(
            first: 0
            where: {
                status: PUBLISH
                parent: $id
                taxQuery: {
                    relation: AND
                    taxArray: [
                        { field: SLUG, taxonomy: INVESTMENTTYPE, terms: "flat" }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTSTATUS
                            terms: "booked"
                        }
                    ]
                }
            }
        ) {
            pageInfo {
                total
            }
        }
        soldFlats: investments(
            first: 0
            where: {
                status: PUBLISH
                parent: $id
                taxQuery: {
                    relation: AND
                    taxArray: [
                        { field: SLUG, taxonomy: INVESTMENTTYPE, terms: "flat" }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTSTATUS
                            terms: "sold"
                        }
                    ]
                }
            }
        ) {
            pageInfo {
                total
            }
        }
    }
`;

export const GARAGES_STATISTICS = gql`
    query GaragesCountsByBuilding($investmentBuilding: [String], $id: ID!) {
        availableGarages: investments(
            first: 0
            where: {
                status: PUBLISH
                parent: $id
                taxQuery: {
                    relation: AND
                    taxArray: [
                        {
                            field: SLUG
                            taxonomy: INVESTMENTTYPE
                            terms: "garage"
                        }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTBUILDING
                            terms: $investmentBuilding
                        }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTSTATUS
                            terms: "available"
                        }
                    ]
                }
            }
        ) {
            pageInfo {
                total
            }
        }
        bookedGarages: investments(
            first: 0
            where: {
                status: PUBLISH
                parent: $id
                taxQuery: {
                    relation: AND
                    taxArray: [
                        {
                            field: SLUG
                            taxonomy: INVESTMENTTYPE
                            terms: "garage"
                        }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTBUILDING
                            terms: $investmentBuilding
                        }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTSTATUS
                            terms: "booked"
                        }
                    ]
                }
            }
        ) {
            pageInfo {
                total
            }
        }
        soldGarages: investments(
            first: 0
            where: {
                status: PUBLISH
                parent: $id
                taxQuery: {
                    relation: AND
                    taxArray: [
                        {
                            field: SLUG
                            taxonomy: INVESTMENTTYPE
                            terms: "garage"
                        }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTBUILDING
                            terms: $investmentBuilding
                        }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTSTATUS
                            terms: "sold"
                        }
                    ]
                }
            }
        ) {
            pageInfo {
                total
            }
        }
    }
`;

export const STORAGE_ROOMS_STATISTICS = gql`
    query StoragesCountsByBuilding($investmentBuilding: [String], $id: ID!) {
        availableStorages: investments(
            first: 0
            where: {
                status: PUBLISH
                parent: $id
                taxQuery: {
                    relation: AND
                    taxArray: [
                        {
                            field: SLUG
                            taxonomy: INVESTMENTTYPE
                            terms: "storage-room"
                        }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTBUILDING
                            terms: $investmentBuilding
                        }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTSTATUS
                            terms: "available"
                        }
                    ]
                }
            }
        ) {
            pageInfo {
                total
            }
        }
        bookedStorages: investments(
            first: 0
            where: {
                status: PUBLISH
                parent: $id
                taxQuery: {
                    relation: AND
                    taxArray: [
                        {
                            field: SLUG
                            taxonomy: INVESTMENTTYPE
                            terms: "storage-room"
                        }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTBUILDING
                            terms: $investmentBuilding
                        }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTSTATUS
                            terms: "booked"
                        }
                    ]
                }
            }
        ) {
            pageInfo {
                total
            }
        }
        soldStorages: investments(
            first: 0
            where: {
                status: PUBLISH
                parent: $id
                taxQuery: {
                    relation: AND
                    taxArray: [
                        {
                            field: SLUG
                            taxonomy: INVESTMENTTYPE
                            terms: "storage-room"
                        }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTBUILDING
                            terms: $investmentBuilding
                        }
                        {
                            field: SLUG
                            taxonomy: INVESTMENTSTATUS
                            terms: "sold"
                        }
                    ]
                }
            }
        ) {
            pageInfo {
                total
            }
        }
    }
`;
